import { ref } from '@vue/composition-api'

export default function useDriverUserReviews(type, id, ctx) {
  const rating = ref(null)
  const reviews = ref(null)
  const fetchReviews = async () => {
    try {
      rating.value = null
      const res = await ctx.root.$store.dispatch('reviews/fetchReviews', {
        reviewableType: type,
        reviewableId: id,
      })
      const response = res.data.data
      rating.value = response.statistics.average
      reviews.value = response.reviews
    } catch (err) {
      console.log(err)
    }
  }
  fetchReviews()
  return {
    rating,
    fetchReviews,
    reviews,
  }
}
